// import moment from "moment";
import Vue from "vue";
import Formatter from "@/hive/Formatter";

Vue.filter("timestamp", (ts, time) => {
  return Formatter.timestamp(ts, time);
});
Vue.filter("date", date => {
  return Formatter.date(date);
});
Vue.filter("friendlyTime", ts => {
  return Formatter.friendlyTime(ts);
});
